import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, forkJoin, map, switchMap, takeUntil } from 'rxjs';
import { errMessage } from '@ui';
import { PolygonsService } from '../../services/polygons.service';
import { PolygonsActions } from '../state/polygons/polygons.actions';
import { OrganizationActions } from '../state/organization/organization.actions';
import { UserActions } from '../state/user/user.actions';
import { SharedActions } from '../state/shared/shared.actions';

export const loadPolygons$ = createEffect(
  (actions$ = inject(Actions), service = inject(PolygonsService)) =>
    actions$.pipe(
      ofType(PolygonsActions.load),
      switchMap(({ query, append }) =>
        forkJoin({ items: service.list(query), stats: service.stats() }).pipe(
          map(({ items, stats }) =>
            PolygonsActions.loaded({ items, stats, append: !!append }),
          ),
          catchError((error: unknown) => [
            PolygonsActions.failed(),
            SharedActions.showMessage({ error: errMessage(error as Error) }),
          ]),
          takeUntil(
            actions$.pipe(
              ofType(
                PolygonsActions.reset,
                OrganizationActions.setActiveOrganization,
                OrganizationActions.resetToInitialState,
                UserActions.resetToInitialState,
              ),
            ),
          ),
        ),
      ),
    ),
  { functional: true },
);
